import Image from "next/image";
import dynamic from "next/dynamic";

const DynamicImage = ({
  src,
  alt = '微友智汇SaaS平台',
  width,
  height,
  className,
  style,
  onClick
}: {
  src: string;
  alt?: string;
  width?: number;
  height?: number;
  className?: string;
  style?: Object
  onClick?: () => void;
}) => {
  // const ImageComponent = dynamic(() => import("next/image"), {
  //   // loading: () => <p>Loading...</p>,
  //   ssr: false, // 禁用服务器端渲染
  // });
  return (
    <Image
      src={src}
      alt={alt || "Dynamic Image"}
      width={width || 500}
      className={className}
      style={style}
      height={height || 500}
      unoptimized // 启用 unoptimized 属性
      onClick={onClick}
    />
  );
};

export default DynamicImage;
